import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=38c2512e&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=38c2512e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2512e",
  null
  
)

export default component.exports